import React from "react";
import ReactDOM from "react-dom/client";

import { PrimeReactProvider } from "primereact/api";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeicons/primeicons.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
